import React, { useEffect, useState } from "react";
import { YhPageHeader } from "@/components/YhPageHeader";
import { TopButs } from "./TopButs";
import { FormBox } from "./FormBox";
import { TableBox } from "./TableBox";
import { FixedBottom } from "./FixedBottom";
import useNavModel, { RouterParamType } from "@/model/navModel";

export const BmsPoDetails = () => {
    const { getSelectedNavState } = useNavModel(() => []);
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);

    return (
        <>
            {detailsInfo && <>
                {/* <YhPageHeader title={`采购单${detailsInfo.mode === "edit" ? "编辑" : "新增"}`} /> */}
                <TopButs {...detailsInfo} />
                <FormBox {...detailsInfo} />
                <TableBox {...detailsInfo} />
                <FixedBottom {...detailsInfo} />
            </>
            }
        </>
    )
}